import { render, staticRenderFns } from "./RecessDaysReport.vue?vue&type=template&id=1c1a9c0c&scoped=true"
import script from "./RecessDaysReport.vue?vue&type=script&lang=js"
export * from "./RecessDaysReport.vue?vue&type=script&lang=js"
import style0 from "./RecessDaysReport.vue?vue&type=style&index=0&id=1c1a9c0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1a9c0c",
  null
  
)

export default component.exports